import React, { useEffect, useState } from 'react';

import Globetrotter from '@reuters-graphics/chart-module-globetrotter';
import LoaderPanel from 'Components/common/LoaderPanel';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';
import fetchJson from 'Utils/fetchJson';
import { globalTopojsonURL } from 'Constants/locations';
import useObservable from 'Components/hooks/observed';
import useWindowDimensions from 'Components/hooks/useWindowDimensions';

const globe = new Globetrotter();
const chartContainer = React.createRef();

const Globe = ({ location, spin = false, fetchedJson }) => {
  const [topojson, setTopojson] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const isVisible = useObservable({ ref: chartContainer, rootMargin: '500px' });
  const { width: windowWidth } = useWindowDimensions();

  const resize = debounce(() => {
    if (!topojson) return;
    globe.draw();
  }, 250);

  useEffect(() => {
    if (topojson) return;
    if (window.localStorage.getItem('globetopo')) {
      setTopojson(JSON.parse(window.localStorage.getItem('globetopo')));
      return;
    }
    fetchJson(globalTopojsonURL)
      .then(topojson => {
        setTopojson(topojson);
        window.localStorage.setItem('globetopo', JSON.stringify(topojson));
      });
  }, [topojson]);

  useEffect(() => {
    if (!topojson) return;
    globe
      .selection(chartContainer.current)
      .topojson(topojson)
      .location(location === 'world' ? null : location, spin ? [0, 20] : null)
      .props({
        marker: {
          replacementThreshold: 40,
        },
        spin: isVisible ? spin : false,
        spinSpeed: 6000,
      })
      .draw();
    setShowLoader(false);
    fetchedJson();
  }, [fetchedJson, location, topojson, spin, isVisible]);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className={classnames(component, 'chart-container')}>
      <div className='globetrotter-chart-container' ref={chartContainer} />
      {showLoader && (
        <LoaderPanel height={windowWidth <= 600 ? 140 + 7 : 200 + 7} />
      )}
    </div>
  );
};

export default Globe;
